module.exports = __webpack_public_path__ + "img/huojiaAppImage.b38efe88.png";